<template>
  <USelectMenu
    v-model="_value"
    :items="courses"
    label-key="name"
    by="idCourse"
    placeholder="Select a course"
    :filter-fields="['name']"
    v-bind="$attrs"
  >
    <template #default="{ modelValue: selected }">
      <div v-if="selected" class="flex items-center justify-between w-full h-full pr-2 text-sm text-gray-800 dark:text-gray-100">
        <div>
          <p class="text-gray-800 dark:text-gray-100">
            {{ selected.name }}
          </p>
        </div>
      </div>
    </template>

    <template #item="{ item }">
      <div v-if="item" class="w-full flex items-center justify-between">
        <div>
          <p class="text-gray-800 dark:text-gray-100">
            {{ item.name }}
          </p>
        </div>
      </div>
    </template>
  </USelectMenu>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'

interface Props {
  modelValue?: any
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: any): void
}>()

const { $api, $notification } = useNuxtApp()

const courses = ref<any[]>([])

const _value = computed({
  get () {
    return props.modelValue
  },
  set (value) {
    emit('update:modelValue', value)
  },
})

// created logic
fetchCourses()

async function fetchCourses () {
  try {
    const response = await $api.course.list()
    courses.value = response.items
  } catch (e: any) {
    $notification.error({ errors: e?.errors })
  }
}
</script>
